import {Injectable} from "@angular/core";
import {
  DirectMessageIssueDto,
  DirectMessageIssuePreviewDto,
  MessageIssueDto,
  MessageIssuePreviewDto, SubmitDirectMessageIssueDto,
  SubmitMessageIssueDto
} from "@server-models";
import {Observable} from "rxjs";
import {IIssueService} from "@shared/components/issues/interfaces/issue-service.interface";
import {SharedIssueApiService} from "@shared/components/issues/services/shared-issue-api.service";

@Injectable({
  providedIn: 'root',
})
export class TeamIssueDirectMessageApiService extends SharedIssueApiService implements IIssueService {

  getIssuePreview(templateId: number): Observable<DirectMessageIssuePreviewDto> {
    return super.get<DirectMessageIssuePreviewDto>(`/tech/v2/issue/directmessage/template/${ templateId }/preview`, undefined);
  }

  getIssue(issueId: number): Observable<DirectMessageIssueDto> {
    return super.get<DirectMessageIssueDto>(`/tech/v2/issue/directmessage/${ issueId }`);
  }

  sendIssueTemplatePreviewById(templateId: number, issue: SubmitDirectMessageIssueDto): Observable<void> {
    return super.post<void>(`/tech/v2/issue/directmessage/template/${ templateId }/submitIssue`, undefined, issue);
  }

}
